import React, {createContext, useReducer} from 'react'
import {ReceiverFilterReducer} from "../reducers/ReceiveFilterReducer";

export const ReceiveFilterContext = createContext();

const ReceiveFilterContextProvider = (props) => {
    const [ cycles, dispatch ] = useReducer(ReceiverFilterReducer,{selectedCycles:[], allCycles:[]});
    return (
        <ReceiveFilterContext.Provider value = {{cycles, dispatch}}>
            {props.children}
        </ReceiveFilterContext.Provider>
    )
}

export default ReceiveFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/receive/context/ReceiveFilterContext.js